import {getDirectMessageThreadId} from "./direct-message-notification-read";
import type {NotificationItem} from "../types";

/** Bell triage: one unread row per DM thread (newest wins; list is already sorted). */
export function dedupeNotificationsForTriage(items: NotificationItem[]): NotificationItem[] {
  const dmThreadSeen = new Set<number>();

  return items.filter((item) => {
    const threadId = getDirectMessageThreadId(item);
    if (threadId == null) {
      return true;
    }
    if (dmThreadSeen.has(threadId)) {
      return false;
    }
    dmThreadSeen.add(threadId);
    return true;
  });
}
